/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCtmsCategoryOptionRespVo
 */
export interface GetCtmsCategoryOptionRespVo {
    /**
     * 类目编号
     * @type {number}
     * @memberof GetCtmsCategoryOptionRespVo
     */
    code?: number;
    /**
     * 类目名称
     * @type {string}
     * @memberof GetCtmsCategoryOptionRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the GetCtmsCategoryOptionRespVo interface.
 */
export function instanceOfGetCtmsCategoryOptionRespVo(value: object): value is GetCtmsCategoryOptionRespVo {
    return true;
}

export function GetCtmsCategoryOptionRespVoFromJSON(json: any): GetCtmsCategoryOptionRespVo {
    return GetCtmsCategoryOptionRespVoFromJSONTyped(json, false);
}

export function GetCtmsCategoryOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCtmsCategoryOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetCtmsCategoryOptionRespVoToJSON(json: any): GetCtmsCategoryOptionRespVo {
    return GetCtmsCategoryOptionRespVoToJSONTyped(json, false);
}

export function GetCtmsCategoryOptionRespVoToJSONTyped(value?: GetCtmsCategoryOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

